/**
 * Shell de la PWA: rutas y arranque.
 *
 * El arranque intenta validar la sesión contra el servidor, pero si no hay red
 * usa el perfil cacheado: la app DEBE abrir sin señal, porque el encuestador
 * puede empezar la jornada en una zona sin cobertura (La Rumorosa, El Hongo).
 */

import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { startAutoSync } from './db/queue';
import { useApp, watchConnectivity } from './store';
import { AssignmentScreen } from './screens/Assignment';
import { ChangePasswordScreen, LoginScreen } from './screens/Auth';
import { HomeScreen } from './screens/Home';
import { HouseholdScreen } from './screens/Household';
import { InterviewScreen } from './screens/Interview';
import { SettingsScreen } from './screens/Settings';
import { SyncScreen } from './screens/Sync';

export function App() {
  const { isAuthenticated, isBootstrapping, operator, bootstrap } = useApp();

  useEffect(() => {
    void bootstrap();
    const stopConnectivity = watchConnectivity();
    const stopAutoSync = startAutoSync();
    return () => {
      stopConnectivity();
      stopAutoSync();
    };
  }, [bootstrap]);

  if (isBootstrapping) {
    return (
      <div className="center-screen">
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) return <LoginScreen />;

  // El API bloquea el resto de las rutas hasta el cambio de contraseña, así que
  // no tiene sentido mostrar nada más.
  if (operator?.mustChangePassword) return <ChangePasswordScreen />;

  return (
    <Routes>
      <Route path="/" element={<HomeScreen />} />
      <Route path="/asignacion/:assignmentId" element={<AssignmentScreen />} />
      <Route path="/vivienda/:assignmentId" element={<HouseholdScreen />} />
      <Route path="/entrevista/:clientUuid" element={<InterviewScreen />} />
      <Route path="/sincronizacion" element={<SyncScreen />} />
      <Route path="/ajustes" element={<SettingsScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
